import Home from '../pages/Home'
import Work from '../pages/Work/work.vue'
import Insurance from '../pages/Insurance/insurance.vue'
import Service from '../pages/Service/service.vue'
import Cancel from '../pages/Cancel/cancel.vue'
import Safety from '../pages/Safety/safety.vue'
import Search from '../pages/Search/search.vue'
import News from '../pages/News/news.vue'
import Polit from '../pages/Polit/polit.vue'
import Ussage from '../pages/Polit/polit.vue'
import Rate from '../pages/Rate/rate.vue'
import Logout from '../layouts/logout.vue'
import Payment from '../pages/Cancel/inf_page/payment.vue'
import Send from '../pages/Cancel/inf_page/send.vue'
import Privacy from '../pages/Privacy/privacy.vue'
import Article from '../pages/Article/article.vue'
import articleOne from '../pages/Article/articleOne/articleOne.vue'
import articleTwo from '../pages/Article/articleTwo/articleTwo.vue'
import articleThree from '../pages/Article/articleThree/articleThree.vue'
import articleFour from '../pages/Article/articleFour/articleFour.vue'
import articleFive from '../pages/Article/articleFive/articleFive.vue'
// import public_offerta from '../pages/public_offerta/public_offerta.vue'
import Pay from '../pages/Payment/payment.vue'
const env = require('../../env.json');

const routes = [
  { path: '/pay', component: Pay },
  { 
    path: '/send', component: Send, 
    meta: { 
      title: 'info',
      name: 'info'
    },
  },
  { 
    path: '/payment', component: Payment, 
    meta: { 
      title: 'info',
      name: 'info'
    },
  },
  { path: '/', component: Home },
  { path: '/work', component: Work },
  { path: '/insurance', component: Insurance },
  { path: '/service', component: Service },
  { path: '/cancel', component: Cancel },  
  { path: '/safety', component: Safety }, 
  { path: '/search', component: Search },
  { path: '/article', component: Article },
  { path: '/news', component: News },
  { path: '/polit', component: Polit },
  { path: '/privacy', component: Privacy },
  { path: '/ussage', component: Ussage },
  { path: '/rate', component: Rate },
  { path: '/article/how-to-choose-a-reliable-lawyer', component: articleOne },
  { path: '/article/what-is-a-secure-transaction', component: articleTwo },
  { path: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results', component: articleThree },
  { path: '/article/lzheyuristi-v-rossii', component: articleFour },
  { path: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator', component: articleFive },
  // { path:'/public_offerta', component: public_offerta},
  {
    path: '/profile',
    beforeEnter(to, from, next) {
      if(to.query.id){
        location.href = `${env.lk}/profile?id=${to.query.id}`
      }else{
        location.href = `${env.lk}/profile`
      }
    }
  },
  {
    path: '/preferences',
    beforeEnter() {location.href = `${env.lk}/preferences`}
  },
  {
    path: '/support',
    beforeEnter() {location.href = `${env.lk}/support`}
  },
  {
    path: '/finance',
    beforeEnter() {location.href = `${env.lk}/finance`}
  },
  {
    path: '/deals',
    beforeEnter() {location.href = `${env.lk}/deals`}
  },
  {
    path: '/chat',
    beforeEnter() {location.href = `${env.lk}/chat`}
  },
  {
    path: '/create_ticket',
    beforeEnter(to, from, next) {
      if(to.query.id){
      location.href = `${env.lk}/create_ticket?id=${to.query.id}`
      }else{
        location.href = `${env.lk}/create_ticket`
      }
    }
  },
  {
    path: '/admin/finance_statistic',
    beforeEnter() {location.href = `${env.lk}/admin/finance_statistic`}
  },
  {
    path: '/admin/ministry_of_justice',
    beforeEnter() {location.href = `${env.lk}/admin/ministry_of_justice`}
  },
  {
    path: '/admin/help',
    beforeEnter() {location.href = `${env.lk}/admin/modals/help`}
  },
  {
    path: '/admin/judges',
    beforeEnter() {location.href = `${env.lk}/admin/judges`}
  },
  {
    path: '/admin/user',
    beforeEnter() {location.href = `${env.lk}/admin/user`}
  },
  {
    path: '/admin/support',
    beforeEnter() {location.href = `${env.lk}/admin/support`}
  },
  {
    path: '/admin/requests',
    beforeEnter() {location.href = `${env.lk}/admin/requests`}
  },
 {
    path: '/admin/lawyers',
    beforeEnter() {location.href = `${env.lk}/admin/lawyers`}
  },
  {
    path: '/admin/settings',
    beforeEnter() {location.href = `${env.lk}/admin/user`}
  },
  {
    path: '/admin/list_disputes',
    beforeEnter() {location.href = `${env.lk}/admin/list_disputes`}
  },
  { path: '/logout', component: Logout },
]

export default routes


// WEBPACK FOOTER //
// ./src/router/routes.js